import React from 'react';
import { Check } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const pains = ['Llegas a fin de mes justo o con deudas y no sabes cómo cambiar eso', 'Tienes habilidades o conocimientos que nadie te está pagando todavía', 'Buscaste formas de generar dinero online pero todo parecía mentira o demasiado complicado', 'Quisieras empezar algo propio pero no tienes tiempo ni capital para invertir', 'Necesitas dinero esta semana específicamente, no en 6 meses'];
export const ProblemBullets = () => {
  return <section className="py-20 md:py-24 bg-[#0a0a0a]" data-id="element-167">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-168">
        <FadeIn data-id="element-169">
          <div className="text-center mb-12" data-id="element-170">
            <span className="text-[#ADFF2F] font-bold tracking-[0.2em] uppercase text-sm mb-4 block" data-id="element-171">
              ¿Te identificas con alguno de estos?
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-white leading-tight" data-id="element-172">
              Si marcas aunque sea uno de estos puntos, este plan es exactamente
              para ti:
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-173">
          <div className="bg-[#111111] border border-white/10 rounded-2xl p-6 md:p-10" data-id="element-174">
            <ul className="space-y-5" data-id="element-175">
              {pains.map((pain, i) => <li key={i} className="flex items-start gap-4" data-id="element-176">
                  <span className="shrink-0 w-7 h-7 rounded-full bg-[#ADFF2F]/15 border border-[#ADFF2F]/40 flex items-center justify-center mt-0.5" data-id="element-177">
                    <Check className="w-4 h-4 text-[#ADFF2F]" strokeWidth={3} data-id="element-178" />
                  </span>
                  <span className="text-base md:text-lg text-gray-300 leading-relaxed font-sans" data-id="element-179">
                    {pain}
                  </span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-180">
          <div className="mt-8 border-2 border-[#ADFF2F] bg-[#ADFF2F]/5 rounded-xl p-6 text-center" data-id="element-181">
            <p className="text-white text-lg md:text-xl font-medium font-sans m-0" data-id="element-182">
              <span className="text-[#ADFF2F] font-bold" data-id="element-183">No estás solo.</span>{' '}
              Exactamente para esa situación fue creado este plan.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
};